import Diagram from "beautiful-react-diagrams";
import '../styles/UncontrolledDiagram.scss';


/**
 * A shitty wrapper for a shitty library.
 * @param {any} props the props if u know what i mean :/ 
 * @return {JSX.Element}
 */
export default function DiagramWrapper(props) {
    return (
        <Diagram schema={props.schema} onChange={props.onChange} />
    );
}